import React, { useState } from "react";
import { Download, Sparkles } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { downloadPdf } from "./FileUpload";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const usd = (v) => `$${Number(v || 0).toFixed(2)}`;

export function EarlyBirdReport() {
  const [year, setYear] = useState("");
  const { data } = useApi(`/admin/dues/early-bird/report${year ? `?year=${year}` : ""}`, [year]);
  if (!data) return null;
  const rows = data.items;
  return (
    <div className="mt-8 glass rounded-2xl p-6" data-testid="early-bird-report">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2"><Sparkles size={18} className="text-gold" />
          <div><h3 className="font-serif-display text-xl font-bold text-crimson">Early-payment discounts</h3>
            <p className="text-xs text-muted-foreground">{data.count} member{data.count === 1 ? "" : "s"} · {usd(data.total_discount)} in discounts · {usd(data.total_paid)} collected early in {data.year}</p></div></div>
        <div className="flex items-center gap-2">
          <Select value={String(data.year)} onValueChange={setYear}><SelectTrigger className="h-9 w-28" data-testid="eb-report-year"><SelectValue /></SelectTrigger>
            <SelectContent>{data.years.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</SelectContent></Select>
          <Button variant="outline" className="h-9 gap-2" onClick={() => downloadPdf(`/admin/dues/early-bird/report.csv?year=${data.year}`, `early-payment-discounts-${data.year}.csv`)} disabled={!rows.length} data-testid="eb-report-csv"><Download size={15} /> CSV</Button>
        </div>
      </div>
      {rows.length === 0 ? <p className="mt-4 text-sm text-muted-foreground" data-testid="eb-report-empty">No early-payment discounts granted for {data.year} yet.</p> : (<>
        <div className="mt-4 space-y-2 lg:hidden">
          {rows.map((r) => (
            <div key={r.member_id} className="rounded-xl border border-gold/25 bg-parchment-card p-3 text-sm" data-testid={`eb-card-${r.member_id}`}>
              <div className="flex justify-between gap-2"><p className="font-semibold">{r.name}</p><span className="font-mono-accent font-semibold text-palm">−{usd(r.discount)}</span></div>
              <p className="text-xs text-muted-foreground">{r.member_no} · paid {usd(r.payment_amount)} via {r.payment_method} on {r.paid_at}</p>
            </div>
          ))}
        </div>
        <div className="mt-4 hidden overflow-x-auto lg:block">
          <table className="w-full text-sm" data-testid="eb-report-table">
            <thead className="bg-crimson text-parchment"><tr><th className="p-3 text-left">Member</th><th className="p-3 text-left">Chapter</th><th className="p-3 text-right">Paid</th><th className="p-3 text-left">Method</th><th className="p-3 text-left">Receipt</th><th className="p-3 text-left">Paid on</th><th className="p-3 text-right">Discount</th><th className="p-3 text-left">Credited</th></tr></thead>
            <tbody>{rows.map((r) => (
              <tr key={r.member_id} className="border-b border-gold/15" data-testid={`eb-row-${r.member_id}`}>
                <td className="p-3">{r.name} <span className="font-mono-accent text-xs text-muted-foreground">{r.member_no}</span></td><td className="p-3">{r.chapter}</td>
                <td className="p-3 text-right font-mono-accent">{usd(r.payment_amount)}</td><td className="p-3 capitalize">{r.payment_method}</td><td className="p-3 font-mono-accent text-xs">{r.receipt_no}</td>
                <td className="p-3">{r.paid_at}</td><td className="p-3 text-right font-mono-accent font-semibold text-palm">−{usd(r.discount)}</td><td className="p-3">{r.granted_at}</td>
              </tr>))}</tbody>
          </table>
        </div>
      </>)}
    </div>
  );
}
